'use client';

import { For, SegmentGroup } from '@chakra-ui/react';
import * as React from 'react';

export interface SegmentedControlProps extends SegmentGroup.RootProps {
	items: Array<Item | string>
}

interface Item {
	disabled?: boolean
	label:     React.ReactNode
	value:     string
}

function normalize(items: Array<Item | string>): Item[] {
	return items.map((item) => {
		if (typeof item === 'string')
			return {
				label: item,
				value: item,
			};

		return item;
	});
}

export const SegmentedControl = React.forwardRef<HTMLDivElement, SegmentedControlProps>(function SegmentedControl(props, ref) {
	const { items, ...rest } = props;
	const data = React.useMemo(() => normalize(items), [ items ]);

	return (
		<SegmentGroup.Root ref={ref} {...rest}>
			<SegmentGroup.Indicator />
			<For each={data}>
				{item => (
					<SegmentGroup.Item disabled={item.disabled} key={item.value} value={item.value}>
						<SegmentGroup.ItemText>
							{item.label}
						</SegmentGroup.ItemText>
						<SegmentGroup.ItemHiddenInput />
					</SegmentGroup.Item>
				)}
			</For>
		</SegmentGroup.Root>
	);
});
